module.exports = __webpack_public_path__ + "static/media/awesome.ceebae1f.svg";